import { isS12nEligibleForCourseraPlusUpgrade } from 'bundles/coursera-plus-common/utils/courseraPlusUpgradeUtils';
import {
  ENROLL_THROUGH_S12N_SUBSCRIPTION,
  PURCHASE_SINGLE_COURSE,
} from 'bundles/enroll-course/common/EnrollmentChoiceTypes';
import {
  choiceTypeToHandleSubmitPromise,
  submitEnrollmentPromise,
} from 'bundles/enroll-course/lib/enrollmentChoiceUtils';
import type { EnrollmentChoices } from 'bundles/enroll/components/xdp/withEnrollment';
import {
  getCanEnrollThroughS12nSubscriptionFreeTrial,
  getS12nMonthlySkuId,
} from 'bundles/enroll/utils/mixAndMatchUtils';

export type straightToCheckoutEnrollParameters = {
  s12nId?: string;
  courseId: string;
  enrollmentAvailableChoices?: EnrollmentChoices;
};

const straightToCheckoutEnroll = async ({
  s12nId,
  courseId,
  enrollmentAvailableChoices,
}: straightToCheckoutEnrollParameters) => {
  if (!s12nId && !courseId) {
    return null;
  }

  if (!s12nId && courseId && enrollmentAvailableChoices?.canPurchaseSingleCourse) {
    const handleSubmitPromise = choiceTypeToHandleSubmitPromise[PURCHASE_SINGLE_COURSE];
    const options = { courseId };
    return submitEnrollmentPromise({
      handleSubmitPromise,
      options,
    });
  }
  const enrollmentData = { enrollmentAvailableChoices, s12nId: s12nId ?? '' };

  let skipWelcomeEmail = false;
  if (s12nId && getCanEnrollThroughS12nSubscriptionFreeTrial(enrollmentData)) {
    skipWelcomeEmail = await isS12nEligibleForCourseraPlusUpgrade(s12nId);
  }

  const handleSubmitPromise = choiceTypeToHandleSubmitPromise[ENROLL_THROUGH_S12N_SUBSCRIPTION];
  const options = { productSkuId: getS12nMonthlySkuId(enrollmentData), courseId, skipWelcomeEmail };

  return submitEnrollmentPromise({
    handleSubmitPromise,
    options,
  });
};

export default straightToCheckoutEnroll;
